import { SubmissionStatus } from '../services/graphql/types/graphql';

const SUBMITTED_BADGE_STATUSES = new Set<SubmissionStatus>([
  SubmissionStatus.Submitted,
  SubmissionStatus.TaApproved,
  SubmissionStatus.Resubmitted,
  SubmissionStatus.Completed,
]);

export const isJingguiSubmissionSubmitted = (status?: SubmissionStatus | null): boolean => {
  if (!status) {
    return false;
  }
  return SUBMITTED_BADGE_STATUSES.has(status);
};

export const isJingguiReviewBadgeYellow = (status?: SubmissionStatus | null): boolean => {
  return status === SubmissionStatus.ChangeRequested;
};

export const isJingguiReviewBadgeGreen = (status?: SubmissionStatus | null): boolean => {
  return status === SubmissionStatus.Completed;
};

export const canJingguiEditAssignment = (status?: SubmissionStatus | null): boolean => {
  return (
    status == null ||
    status === SubmissionStatus.Unsubmitted ||
    status === SubmissionStatus.ChangeRequested
  );
};

export const canJingguiSubmitAssignment = (
  status: SubmissionStatus | null | undefined,
  mediaCount: number,
  minQuantity: number,
  _reviewFlowEnabled?: boolean | null,
): boolean => {
  if (mediaCount < minQuantity) {
    return false;
  }

  if (
    status == null ||
    status === SubmissionStatus.Unsubmitted ||
    status === SubmissionStatus.ChangeRequested
  ) {
    return true;
  }

  return false;
};

/** Student may withdraw a formal submit before teacher publishes comments or final grade. */
export const canJingguiWithdrawSubmission = (
  status: SubmissionStatus | null | undefined,
  latestReviewPublishedAt?: string | null,
): boolean => {
  if (latestReviewPublishedAt) {
    return false;
  }

  return (
    status === SubmissionStatus.Submitted || status === SubmissionStatus.TaApproved
  );
};
